import { getThemeFromDomain } from './themeDomain';

export const BASE_DOMAINS = [
  'saledesk.co.uk',
  'saledesk.pk',
  'getkashly.com',
  'kashly.local',
  'saas-pos.local',
];
const RESERVED_SUBDOMAINS = new Set([
  'pos',
  'devpos',
  'devapi',
  'www',
  'app',
  'api',
  'admin',
  'ksa',
  'ksaapi',
  'devksa',
  'devksaapi',
  'uk',
  'ukapi',
  'devuk',
  'devukapi',
  'pos.saledesk.co.uk',
  'api.saledesk.co.uk',
  'pos.saledesk.pk',
  'api.saledesk.pk',
]);

export function getAppBaseDomain(hostname = window.location.hostname): string {
  const host = hostname.toLowerCase();
  if (host.includes('kashly') || getThemeFromDomain() === 'kashly') {
    return 'getkashly.com';
  }
  for (const base of BASE_DOMAINS) {
    if (host.includes(base)) return base;
  }
  return 'saledesk.co.uk';
}

export type TenantLoginContext = {
  isTenantLogin: boolean;
  subdomain: string | null;
};

export function getTenantLoginContext(hostname = window.location.hostname): TenantLoginContext {
  const host = hostname.toLowerCase();
  if (
    !host ||
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === 'pos.saledesk.co.uk' ||
    host === 'api.saledesk.co.uk' ||
    host === 'devpos.saledesk.co.uk' ||
    host === 'devapi.saledesk.co.uk' ||
    host === 'devpos.saledesk.pk' ||
    host === 'devapi.saledesk.pk'
  ) {
    return { isTenantLogin: false, subdomain: null };
  }

  for (const base of BASE_DOMAINS) {
    if (host === base) {
      return { isTenantLogin: false, subdomain: null };
    }
    const suffix = `.${base}`;
    if (host.endsWith(suffix)) {
      const subdomain = host.slice(0, -suffix.length);
      if (!subdomain || subdomain.includes('.') || RESERVED_SUBDOMAINS.has(subdomain)) {
        return { isTenantLogin: false, subdomain: null };
      }
      return { isTenantLogin: true, subdomain };
    }
  }

  return { isTenantLogin: false, subdomain: null };
}
